export const FREE_GRAMMAR_EMPTY_STATE = 'FREE_GRAMMAR_EMPTY_STATE'
export const PLAGIARISM_CHECK_MIDPANEL = 'PLAGIARISM_CHECK_MIDPANEL'
export const PLAGIARISM_RECHECK_MIDPANEL = 'PLAGIARISM_RECHECK_MIDPANEL'
export const GRAMMAR_MIDPANEL_PLAGIARISM_CHECK = 'GRAMMAR_MIDPANEL_PLAGIARISM_CHECK'
export const GRAMMAR_MIDPANEL_CHECK = 'GRAMMAR_MIDPANEL_CHECK'
export const CHECK_ERROR_TRY_AGAIN = 'CHECK_ERROR_TRY_AGAIN'
export const GRAMMAR_MIDPANEL_ERROR = 'GRAMMAR_MIDPANEL_ERROR'
export const PLAGIARISM_MIDPANEL_ERROR = 'PLAGIARISM_MIDPANEL_ERROR'

export const EMPTY_STATE = 'emptyState'
export const CTA_TEXT_READY_PLAGIARISM = 'Check my paper'
export const PLAG_COMPLETE_NO_COMMENTS_SUB_TEXT =
  "We couldn't find any plagiarism in this masterpiece"
export const PLAG_NOT_ENOUGH_TEXT_TEXT = 'Are you writing a haiku?'
export const PLAG_NOT_ENOUGH_TEXT_SUB_TEXT =
  'Our checker needs at least 20 words to get started.'
export const CTA_TEXT_NOT_ENOUGH_TEXT = 'Try another paper'
export const EMPTY_ERROR_TEXT = "Hmm, that didn't work."
export const CTA_TEXT_EMPTY_ERROR = 'Try again'
export const PLAG_COMPLETE_SUB_TEXT =
  "We couldn't find any more plagiarism in this masterpiece"
export const CTA_TEXT_PLAGIARISM_COMPLETE = 'Check your grammar'
export const CTA_TEXT_GRAMMAR_COMPLETE_FREE = 'Upgrade for plagiarism checks'
export const CTA_TEXT_GRAMMAR_COMPLETE = 'Check for plagiarism'



// WEBPACK FOOTER //
// ./src/layouts/shared/EmptyStates/constants.tsx